import React from 'react';

interface StarRatingProps {
	value: number;
}

const StarRating: React.FC<StarRatingProps> = ({ value }) => {
	const totalStars = 10;
	const stars = [];

	for (let i = 0; i < totalStars; i++) {
		if (i < value) {
			stars.push(<div className="sprite-46 star active"></div>);
		} else {
			stars.push(<div className="sprite-46 star"></div>);
		}
	}

	return <div className="inline-flex mt-1">{stars}</div>;
};

export default StarRating;
